export default __webpack_public_path__ + "static/media/floorplans2.9ab86312.jpg";